<div class="lib-breadcrumbs separator">
    <ol class="breadcrumb fs-5">
        <ng-container *ngFor="let path of paths">
            <li *ngIf="!path.lien" aria-current="page" class="breadcrumb-item active">{{ path.label }}</li>
            <li *ngIf="path.lien" aria-current="page" class="breadcrumb-item active">
                <a [routerLink]="path.lien">{{ path.label }}</a>
            </li>
        </ng-container>
    </ol>
</div>
